import { render } from "./Revolution.vue?vue&type=template&id=35a13916&scoped=true"
import script from "./Revolution.vue?vue&type=script&lang=js"
export * from "./Revolution.vue?vue&type=script&lang=js"

import "./Revolution.vue?vue&type=style&index=0&id=35a13916&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a13916"]])

export default __exports__